document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-kova-reviews]").forEach((section) => {
    const track = section.querySelector("[data-kova-reviews-track]");
    const previous = section.querySelector("[data-kova-reviews-previous]");
    const next = section.querySelector("[data-kova-reviews-next]");
    if (!track || !previous || !next) return;

    const move = (direction) => {
      const cards = track.querySelectorAll(".kova-home__review");
      if (!cards.length) return;
      const current = Math.round(track.scrollLeft / track.clientWidth);
      const destination = (current + direction + cards.length) % cards.length;
      const behavior = matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
      track.scrollTo({ left: destination * track.clientWidth, behavior });
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
  });
});
